import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { OrdersService } from '../../services';
import { AuthActionTypes, OrdersActionTypes } from '@app/core/ngrx';
import { Actions, ofType, createEffect } from '@ngrx/effects';

/**
 * OrdersEpics
 */
@Injectable()
export class OrdersEffects {
  /**
   * constructor
   * @param {OrdersService} ordersService
   */
  constructor(private ordersService: OrdersService, private actions$: Actions) {}

  /**
   * loadOrders
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  loadOrders = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActionTypes.LOAD_ORDERS),
      switchMap(({ payload }: any) => {
        return this.ordersService.getOrders(payload).pipe(
          map((orders) => ({
            type: OrdersActionTypes.LOAD_ORDERS_SUCCESS,
            payload: this.setExpectedDateIfNull(orders),
          })),
          catchError((err) =>
            of({
              type: OrdersActionTypes.LOAD_ORDERS_ERROR,
              payload: { error: 'No Orders Found For Selected Location.' },
            }),
          ),
        );
      }),
    ),
  );

  /**
   * loadOrdersError
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  // loadOrdersError = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(OrdersActionTypes.LOAD_ORDERS_ERROR),
  //     map(() => ({ type: AuthActionTypes.LOGOUT })),
  //   ),
  // );

  setExpectedDateIfNull(orders) {
    let newOrderArray = [];
    if (orders) {
      orders.forEach((order) => {
        if (order.expectedDate === null || order.expectedDate === '') {
          order.expectedDate = '2000-01-11T00:00:01';
        }
        newOrderArray.push(order);
      });
    }
    return newOrderArray;
  }
}
